import React, { Component } from "react";
import { withRouter } from "../../utils/withRouter";
import {
  getAllCategories,
  addCategory,
  deleteCategory,
  getRecipesByCategory,
  addRecipe,
  updateRecipe,
  deleteRecipe
} from "../../api/api";
import "./Home.css";

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      categories: [],
      recipes: [],
      selectedCategory: null,

      // Category
      name: "",
      category_details: "",
      image: null,

      // Recipe
      recipe_id: null,
      recipe_title: "",
      description: "",
      recipe_image: null,

      loading: false,
      isSidebarCollapsed: false
    };
  }
  toggleSidebar = () => {
    this.setState((prev) => ({
      isSidebarCollapsed: !prev.isSidebarCollapsed
    }));
  };
  componentDidMount() {
    this.fetchCategories();
  }

  // ================= CATEGORY =================

  fetchCategories = () => {
    getAllCategories().then((res) => {
      this.setState({ categories: res.data });
    });
  };

  selectCategory = (category) => {
    this.setState({ selectedCategory: category });
    this.fetchRecipes(category.category_id);
  };

  handleCategorySubmit = (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("name", this.state.name);
    formData.append("category_details", this.state.category_details);
    formData.append("image", this.state.image);

    addCategory(formData).then(() => {
      this.setState({ name: "", image: null });
      this.fetchCategories();
    });
  };

  handleDeleteCategory = (id) => {
    deleteCategory(id).then(() => {
      this.fetchCategories();
      this.setState({ recipes: [], selectedCategory: null });
    });
  };

  // ================= RECIPES =================

  fetchRecipes = (category_id) => {
    getRecipesByCategory(category_id).then((res) => {
      this.setState({ recipes: res.data });
    });
  };

  handleRecipeChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleRecipeImage = (e) => {
    this.setState({ recipe_image: e.target.files[0] });
  };

  handleRecipeSubmit = (e) => {
    e.preventDefault();
  
    const {
      recipe_id,
      recipe_title,
      description,
      recipe_image,
      selectedCategory,
    } = this.state;
  
    const formData = new FormData();
  
    formData.append("catgeory_id", selectedCategory.category_id);
    formData.append("recipe_title", recipe_title);
    formData.append("description", description);
  
    // Append image only once
    if (recipe_image) {
      formData.append("image", recipe_image);
    }
  
    if (recipe_id) {
      // Update Recipe
      updateRecipe(recipe_id, formData)
        .then(() => {
          this.resetRecipeForm();
          this.fetchRecipes(selectedCategory.category_id);
        })
        .catch((err) => console.error(err));
    } else {
      // Add Recipe
      addRecipe(formData)
        .then(() => {
          this.resetRecipeForm();
          this.fetchRecipes(selectedCategory.category_id);
        })
        .catch((err) => console.error(err));
    }
  };

  handleEditRecipe = (recipe) => {
    this.setState({
      recipe_id: recipe.recipe_id,
      recipe_title: recipe.recipe_title,
      description: recipe.recipe_description
    });
  };

  handleViewRecipe = (recipe) => {
    this.props.router.navigate(`/recipe-details/${recipe.recipe_id}`);
  };
  handleDeleteRecipe = (id) => {
    deleteRecipe(id).then(() => {
      this.fetchRecipes(this.state.selectedCategory.category_id);
    });
  };

  resetRecipeForm = () => {
    this.setState({
      recipe_id: null,
      recipe_title: "",
      description: "",
      recipe_image: null
    });
  };
  handleLogout = () => {
    localStorage.removeItem("token");
    window.location.href = "admin/login";
  };
  render() {
    const {
      recipes,
      selectedCategory,
      recipe_title,
      description,
      recipe_id
    } = this.state;

    return (
      <div className="container-fluid m-0 p-0  home-div">
        <div className="row">

          {/* SIDEBAR */}
          <div className={this.state.isSidebarCollapsed ? "col-md-1" : "col-md-3"}>
            <div className="bg-light border-end sidebar">
              {/* your sidebar content */}
              {/* LEFT SIDE - CATEGORIES */}
              <div className={`bg-light  border-end sidebar ${this.state.isSidebarCollapsed ? "collapsed" : ""}`}>

                {/* Toggle Button */}
                <button className="btn btn-sm btn-dark mb-3 w-100" onClick={this.toggleSidebar}>
                  {this.state.isSidebarCollapsed ? ">>" : "<<"}
                </button>

                {!this.state.isSidebarCollapsed && <h5>Categories</h5>}

                {/* Add Category Form (hide when collapsed) */}
                {!this.state.isSidebarCollapsed && (
                  <form onSubmit={this.handleCategorySubmit} className="mb-3">
                    <input
                      type="text"
                      className="form-control mb-2"
                      placeholder="Category Name"
                      value={this.state.name}
                      onChange={(e) => this.setState({ name: e.target.value })}
                      required
                    />
                    <input
                      type="text"
                      className="form-control mb-2"
                      placeholder="category_details"
                      value={this.state.category_details}
                      onChange={(e) => this.setState({ category_details: e.target.value })}
                      required
                    />
                    <input
                      type="file"
                      className="form-control mb-2"
                      onChange={(e) => this.setState({ image: e.target.files[0] })}
                      required
                    />
                    <button className="btn btn-primary w-100">
                      Add Category
                    </button>
                  </form>
                )}

                {/* Category List */}
                <ul className="list-group">
                  {this.state.categories.map((cat) => (
                    <li
                      key={cat.category_id}
                      className={`list-group-item p-1 m-0 text-center ${this.state.selectedCategory?.category_id === cat.category_id ? "active" : ""
                        }`}
                      onClick={() => this.selectCategory(cat)}
                      style={{ cursor: "pointer" }}
                    >
                      {/* IMAGE */}
                      <img
                        src={cat.category_image}
                        alt={cat.category_name}
                        className="category-img"
                      />

                      {/* NAME (hide when collapsed? optional) */}
                      <div className="mt-1 small">{cat.category_name}</div>

                      {/* DELETE (only when expanded) */}
                      {!this.state.isSidebarCollapsed && (
                        <button
                          className="btn btn-sm btn-danger mt-1"
                          onClick={(e) => {
                            e.stopPropagation();
                            this.handleDeleteCategory(cat.category_id);
                          }}
                        >
                          X
                        </button>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>

          {/* MAIN CONTENT */}
          <div className={this.state.isSidebarCollapsed ? "col-md-11" : "col-md-9"}>
            {/* your recipes section */}
            {/* RIGHT SIDE - RECIPES */}
            <div className="col-md-9 p-4">
              {selectedCategory ? (
                <>
                  <h4>
                    Recipes - {selectedCategory.category_name}
                  </h4>

                  {/* ADD / UPDATE RECIPE */}
                  <div className="card mb-4 shadow-sm">
                    <div className="card-body">
                      <form onSubmit={this.handleRecipeSubmit}>
                        <div className="row">
                          <div className="col-md-4">
                            <input
                              type="text"
                              name="recipe_title"
                              className="form-control"
                              placeholder="Recipe Name"
                              value={recipe_title}
                              onChange={this.handleRecipeChange}
                              required
                            />
                          </div>

                          <div className="col-md-4">
                            <input
                              type="file"
                              className="form-control"
                              onChange={this.handleRecipeImage}
                            />
                          </div>

                          <div className="col-md-4">
                            <button className="btn btn-success w-100">
                              {recipe_id ? "Update Recipe" : "Add Recipe"}
                            </button>
                          </div>
                        </div>

                        <div className="mt-3">
                          <textarea
                            name="description"
                            className="form-control"
                            placeholder="Description"
                            value={description}
                            onChange={this.handleRecipeChange}
                            required
                          />
                        </div>
                      </form>
                    </div>
                  </div>

                  {/* RECIPE LIST */}
                  <div className="row">
                    {recipes.map((recipe) => (
                      <div
                        className="col-md-4 mb-4"
                        key={recipe.recipe_id}
                        onClick={() => this.handleViewRecipe(recipe)}
                        style={{ cursor: "pointer" }}
                      >
                        <div className="card h-100 shadow-sm">
                          <img
                            src={recipe.recipe_image}
                            className="card-img-top"
                            height="200"
                            alt={recipe.recipe_title}
                          />
                          <div className="card-body">
                            <h6>{recipe.recipe_title}</h6>
                            <p className="small">
                              {recipe.recipe_description}
                            </p>

                            <button
                              className="btn btn-warning btn-sm me-2"
                              onClick={(e) => {
                                e.stopPropagation();
                                this.handleEditRecipe(recipe);
                              }}
                            >
                              Edit
                            </button>

                            <button
                              className="btn btn-danger btn-sm"
                              onClick={(e) => {
                                e.stopPropagation();   // 🔥 IMPORTANT
                                this.handleDeleteRecipe(recipe.recipe_id);
                              }}
                            >
                              Delete
                            </button>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </>
              ) : (
                <h5>Select a category to view recipes</h5>
              )}
            </div>

          </div>

        </div>

      </div>
    );
  }
}

export default withRouter(Home);